/* eslint-disable import/no-anonymous-default-export */
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import OtpVerification from "./auth/otp";
import ResetPassword from "./auth/ResetPassword";
import Dashboard from "./dashboard";
import ManageUser from "./manageUsers";
import ManageUserDetail from "./manageUsers/view";
import ManageSubadmin from "./manageSubadmin";

import ManageNotifications from "./manageNotifications";
import RecievedNotifications from "./recievedNotifications";
import ManageCms from "./manageCms";
import SubadminDetail from "./manageSubadmin/viewSubadmin";
import AddSubadmin from "./manageSubadmin/addSubadmin";
import ManageSubadminRoles from "./manageSubadmin/roles";
import AddRole from "./manageSubadmin/addRole";
import RoleDetail from "./manageSubadmin/viewRole";
import ManageProfile from "./manageProfile";
import EditProfile from "./manageProfile/edit";
import ChangePassword from "./manageProfile/changePassword";
import Edituser from "./manageUsers/edit";

import ManageCategories from "./manage-promotion";
import AddCategory from "./manage-promotion/addPromotion";
import AddNotification from "./manageNotifications/add";
import NotificationDetail from "./manageNotifications/view";
import ManageSystemSettings from "./manageSystemSettings";
import AddEmailTemplate from "./manageSystemSettings/addEmailTemplate";
import ManageProducts from "./manageStores";
import AddProduct from "./manageStores/add";
import ProductDetail from "./manageStores/view";
import ManageQrCode from "./manageQrCode";
import ManageBoostPlans from "./manageRewards";
import AddBoostPlans from "./manageRewards/add";
import BoostPlanDetail from "./manageRewards/view";
import ViewPromotion from "./manage-promotion/viewPromotion";
import ManagePayments from "./manage-transction";
import ViewPayments from "./manage-transction/viewTransction";
import ManageActivityLogs from "./manageActivityLogs";
import ManageReviews from "./manageFeedbackReports";
import ReviewsDetail from "./manageFeedbackReports/view";
import Analytics from "./analytics";
import Support from "./customerSupports";
import SupportView from "./customerSupports/view";
import SupportChat from "./customerSupports/chat";

export default {
  Login,
  ForgotPassword,
  OtpVerification,
  ResetPassword,
  Dashboard,
  ManageUser,
  Edituser,
  ManageUserDetail,
  ManageSubadmin,
  SubadminDetail,
  AddSubadmin,
  ManageSubadminRoles,
  AddRole,
  RoleDetail,

  ManageNotifications,
  AddNotification,
  NotificationDetail,
  RecievedNotifications,
  ManageCms,
  ManageProfile,
  EditProfile,
  ChangePassword,
  ManageSystemSettings,

  ManageCategories,
  AddCategory,
  AddEmailTemplate,
  ManageProducts,
  AddProduct,
  ProductDetail,
  ManageQrCode,
  ManageBoostPlans,
  AddBoostPlans,
  BoostPlanDetail,
  ViewPromotion,
  ManagePayments,
  ViewPayments,
  ManageActivityLogs,
  ManageReviews,
  ReviewsDetail,

  Analytics,
  Support,
  SupportView,
  SupportChat,
};
